const AffiliateCrudModalLangKey = [
	'title_edit',
	'title_notes_view',
	'title_notes_edit',
	'field_name_label',
	'field_name_placeholder',
	'field_date_label',
	'field_date_placeholder',
	'field_percent_label',
	'field_percent_placeholder',
	'field_notes_label',
	'field_notes_placeholder',
	'btn_add_record',
	'btn_update',
	'btn_close'
] as const

type IAffiliateCrudModalLangKey = typeof AffiliateCrudModalLangKey[number]

export type IAffiliateCrudModalLang = {
	affiliate_crud_modal: Record<IAffiliateCrudModalLangKey, string>
}

const langEntries = AffiliateCrudModalLangKey.map(
	(key: IAffiliateCrudModalLangKey) => [key, `affiliate_crud_modal.${key}`]
)

const langObj: Record<IAffiliateCrudModalLangKey, string> = Object.fromEntries(langEntries)

export const AFFILIATE_CRUD_MODAL_LANG_KEY: IAffiliateCrudModalLang = {
	affiliate_crud_modal: langObj
}